// Frontend-only data layer. Stripe Checkout is handled by /api/* serverless
// functions (Vercel in production, FastAPI in the Emergent preview).

import PRODUCTS from "../data/products";

const uuid = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

// ---------- Products ----------
export const fetchProducts = async (params = {}) => {
  const { size, color, gender, min_price, max_price, featured } = params;
  return PRODUCTS.filter((p) => {
    if (size && !p.sizes.includes(String(size).toUpperCase())) return false;
    if (color && p.color !== String(color).toLowerCase()) return false;
    if (gender && p.gender !== String(gender).toLowerCase()) return false;
    if (featured !== undefined && p.featured !== featured) return false;
    if (min_price !== undefined && p.price < Number(min_price)) return false;
    if (max_price !== undefined && p.price > Number(max_price)) return false;
    return true;
  });
};

export const fetchProduct = async (slug) => {
  const product = PRODUCTS.find((p) => p.slug === slug);
  if (!product) {
    const err = new Error("Product not found");
    err.status = 404;
    throw err;
  }
  return product;
};

// ---------- Contact (simulated) ----------
export const submitContact = async (payload) => {
  await new Promise((r) => setTimeout(r, 350));
  return {
    id: uuid(),
    name: payload.name,
    email: payload.email,
    subject: payload.subject || null,
    message: payload.message,
    created_at: new Date().toISOString(),
  };
};

// ---------- Stripe Checkout ----------
export const createCheckoutSession = async ({ items, email }) => {
  const res = await fetch(`/api/create-checkout-session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: items.map((i) => ({
        product_id: i.product_id,
        quantity: i.quantity,
        size: i.size,
        color: i.color || null,
      })),
      origin_url: window.location.origin,
      email: email || null,
    }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `Checkout failed (${res.status})`);
  }
  return res.json();
};

export const getCheckoutStatus = async (sessionId) => {
  const res = await fetch(
    `/api/checkout-status?session_id=${encodeURIComponent(sessionId)}`
  );
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `Status check failed (${res.status})`);
  }
  return res.json();
};
